module.exports = __webpack_public_path__ + "img/11.16817f61.svg";